import axios from "axios";
import DirectoryDemoIdea from '@/directoryDemo/index/idea';
import Spinner from '@/layout/spinner';
export default {
  name: "ideas",
  components: {
    DirectoryDemoIdea: DirectoryDemoIdea,
    Spinner: Spinner
  },
  props: {
    category: String
  },
  data: function data() {
    return {
      inProgress: false,
      expanded: false,
      ideasPerPage: 9,
      ideas: []
    };
  },
  mounted: function mounted() {
    this.getIdeasByCategory();
  },
  watch: {
    category: function category(newVal, oldVal) {
      if (this.inProgress || newVal === oldVal) {
        return;
      }
      this.category = newVal;
      this.getIdeasByCategory();
    }
  },
  computed: {
    /**
     * @returns {[]}
     */
    defaultIdeas: function defaultIdeas() {
      return this.ideas.slice(0, this.ideasPerPage);
    },
    /**
     * @returns {[]}
     */
    extraIdeas: function extraIdeas() {
      return this.ideas.slice(this.ideasPerPage, this.ideasPerPage * 2);
    }
  },
  methods: {
    getIdeasByCategory: function getIdeasByCategory() {
      var _this = this;
      this.inProgress = true;
      return axios.get('/directory-demo/ideas', {
        params: {
          category: this.category
        },
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function (response) {
        // [0] = Display text
        // [1] = Search query
        // [2] = Supplier search count
        // [3] = Product search count
        // [4] = Source
        // [5] = Image URL
        // [6] = Image URL raw
        _this.ideas = response.data;
        _this.inProgress = false;
      }, function (xhr) {
        _this.inProgress = false;
      });
    }
  }
};